export const colors = {
  BLUE: '#2F6EB2',
  DARKBLUE: '#002A5C',
  DARKGRAY: '#828282',
  DARKGREEN: '#219653',
  DARKYELLOW: '#dba302',
  GRAY: '#BDBDBD',
  GREEN: '#60CC74',
  YELLOW: '#FFCE43'
};
export const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
